// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsRemediation = {
  summaryRemediation: "是正項目: {count}",
  summaryRemediationCritical: "重大是正項目: {count}",
  remediationPriorities: {
    warning: "警告",
    critical: "重大",
  },
  remediationCategories: {
    object_space: "オブジェクト空間",
    reference: "参照統治",
  },
  remediationActions: {
    enable_space_governance: "オブジェクト空間を統治下に置く",
    reactivate_object_space: "オブジェクト空間を再有効化する",
    review_readonly_space_policy: "読取専用ポリシーを見直す",
    configure_space_grants: "オブジェクト空間権限を設定する",
    resolve_blocked_delete_assets: "削除阻止資産を解消する",
    normalize_reference_scope: "参照スコープを標準化する",
    review_high_binding_references: "高密度参照を見直す",
    repair_reference_bindings: "資産なし参照バインドを修復する",
    normalize_reference_service: "サービス名を標準化する",
  },
  remediationReasons: {
    space_unmanaged: "オブジェクト空間が未統治",
    space_disabled: "オブジェクト空間が停止中",
    space_readonly: "オブジェクト空間が読取専用",
    space_no_grants: "オブジェクト空間に権限がない",
    space_has_delete_blocked_assets: "削除阻止資産が存在する",
    non_global_scope: "参照スコープが標準化されていない",
    high_binding_count: "参照バインド数が多すぎる",
    binding_without_assets: "資産なし参照バインドがある",
    service_not_normalized: "サービス識別子が標準化されていない",
  },
} as const;
